<template>
  <div>
    <v-container>
      <model-select @getCrud="defineModel"></model-select>
    </v-container>

    <v-container>
      <!-- <v-card> -->
        <component :is="'Create-' + crudModel"></component>
      <!-- </v-card> -->
    </v-container>
    <v-container>
      <!-- <v-card> -->
        <component :is="'List-' + crudModel"></component>
      <!-- </v-card> -->
    </v-container>
  </div>
</template>
<script>
export default {
  components: {
    ModelSelect: () => import("@/components/admin_ckb/ModelSelect"),
    
    CreateCompany: () => import("@/components/admin_ckb/create/CreateCompany"),
    CreateSolution: () => import("@/components/admin_ckb/create/CreateSolution"),
    CreateProposal: () => import("@/components/admin_ckb/create/CreateProposal"),
    CreateFeature: () => import("@/components/admin_ckb/create/CreateFeature"),
    CreateDefaultImportFile: () => import("@/components/admin_ckb/create/CreateDefaultImportFile"),

    ListCompany: () => import("@/components/admin_ckb/list/ListCompany"),
    ListSolution: () => import("@/components/admin_ckb/list/ListSolution"),
    ListProposal: () => import("@/components/admin_ckb/list/ListProposal"),
    ListFeature: () => import("@/components/admin_ckb/list/ListFeature"),
    ListDefaultImportFile: () => import("@/components/admin_ckb/list/ListDefaultImportFile"),

  },
  data(){
    return{
      crudModel: "company",
    }
  },
  methods:{
    defineModel(received){
      this.crudModel = received;
    }
  }
};
</script>